import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getDeviceId() {
  let id = localStorage.getItem("sendit_device");
  if (!id) {
    id =
      (crypto.randomUUID && crypto.randomUUID()) ||
      `dev-${Math.random().toString(36).slice(2)}-${Date.now()}`;
    localStorage.setItem("sendit_device", id);
  }
  return id;
}

export const fetchState = () =>
  axios.get(`${API}/state`, { params: { device_id: getDeviceId() } }).then((r) => r.data);

export const castVote = (coin_id) =>
  axios
    .post(`${API}/vote`, { coin_id, device_id: getDeviceId() })
    .then((r) => r.data);

export const forceShuffle = () =>
  axios
    .post(`${API}/shuffle`, null, { params: { device_id: getDeviceId() } })
    .then((r) => r.data);

export function fmtCountdown(secs) {
  const s = Math.max(0, Math.floor(secs));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return h > 0 ? `${pad(h)}:${pad(m)}:${pad(sec)}` : `${pad(m)}:${pad(sec)}`;
}

export function fmtNum(n) {
  if (n === null || n === undefined) return "—";
  const abs = Math.abs(n);
  if (abs >= 1e9) return `${(n / 1e9).toFixed(1)}B`;
  if (abs >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  if (abs >= 1e3) return `${(n / 1e3).toFixed(1)}K`;
  return `${Math.round(n)}`;
}
